import { useCallback, useState } from 'react';
import { resellerBillingApi } from '@/api/resellerBilling';
import { useRemote } from '@/components/useRemote';

const loadCard = () => resellerBillingApi.getCard();
const loadCharges = () => resellerBillingApi.listCharges();

/**
 * The Billing page's card and charges, one `useRemote` each. `reloadAll()` refetches both after a
 * save or removal (nothing is optimistic) and bumps `version`, which remounts the page's
 * attention banners so they read the new state too.
 */
export function useBillingData() {
  const card = useRemote(loadCard);
  const charges = useRemote(loadCharges);
  const [version, setVersion] = useState(0);
  const reloadCard = card.reload;
  const reloadCharges = charges.reload;

  const reloadAll = useCallback(() => {
    reloadCard();
    reloadCharges();
    setVersion((n) => n + 1);
  }, [reloadCard, reloadCharges]);

  return { card, charges, version, reloadAll };
}
